var _desc, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    strokeWidth: 3,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Taco") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M10 57.567c-7 0-8-6.283-8-14a43.145 43.145 0 0 1 16-34 8.6 8.6 0 0 1 7.309-1.758",
    "data-name": "layer1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17.368 52.191c-6.713-.94-5.572-4.972-4.555-6.47 1.9-2.8-1.1-4.156-2.48-6.463s-1.019-4.912 2.307-6.687c2.127-1.135 3.861-2.85 2.309-6.922-1.812-4.758 3.422-4.82 5.051-6.082 2.439-1.891 1.768-3.07 2-7.223s4.75-5.81 8-4.777c0 0 4.378 2 7.795-.3s7.955.444 6.815 4.309",
    "data-name": "layer2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M12.378 57.206L62 35.567s-2.473-10-5.707-16-9.829-10.455-20.667-6.533-13.557 13.535-14.914 25.072c-1.42 12.053-4 19.461-10.711 19.461",
    "data-name": "layer1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaco);
export default __webpack_public_path__ + "static/media/taco.607cddb7.svg";
export { ForwardRef as ReactComponent };